import { useContext, useEffect, useState } from "react";
import Tab from "../../components/Tab/Tab";
import VehicleDetails from "./View/VehicleDetails";
import CompanyDetails from "./View/CompanyDetails";
import SellerDetails from "./View/SellerDetails";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../images/back.svg";
import FlooringDetails from "./View/FlooringDetails";
import { Button, Checkbox, DatePicker, Modal } from "antd";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import moment from "moment";
import { CommomPermission, FormatCurrency } from "../../common/Constants";
import dayjs from "dayjs";
import useViewportWidth from "../../utils/useViewportWidth";
import DisbursementDeatils from "./View/DisbursementDetails";
import { AuthenticationContext } from "../../App";

const ViewFlooringCases = () => {

  const accessToken = localStorage.getItem("agentModuleToken");
  const navigate = useNavigate();
  const location = useLocation();

  const [caseClose, setcaseClose] = useState({
    open: false,
    type: "Close Case",
    isConfirm: false,
    date: null,
  });
  const [isModelOpen, setisModelOpen] = useState({
    type: "Confirm",
    open: false,
    crntStatus: 1,
    amount: "",
    id: "",
  });
  const [agentRemarks, setAgentRemarks] = useState("");
  const [FloorCaseDetails, setFloorCaseDetails] = useState({});
  const [flooringSettingsData, setFlooringSettingsData] = useState({});

  
  const [activeTab, setActiveTab] = useState(0);
  const [isMobile, setisMobile] = useState(false);
  const [isTab, setisTab] = useState(false);
  const viewportWidth = useViewportWidth();
  const [isReject, setisReject] = useState({ open: false, type: 2 });
  const { authData, setAuthData } = useContext(AuthenticationContext);
  const AgentId = authData ? authData.id : null
  let savedState = location.state;

  if (savedState) {
    localStorage.setItem("agentFloorState", JSON.stringify(savedState));
  } else {
    const storedState = localStorage.getItem("agentFloorState");
    savedState = storedState ? JSON.parse(storedState) : null;
  }
  const pagePermission = CommomPermission;
  const DateValues = {
    submitted_date: savedState?.submitted_date,
    expiry_date: savedState?.expiry_date,
  };
  const isOngoing = savedState?.isOngoing ?? false;
  const AppId = savedState?.appId ?? null;

  const tabs = [
    isOngoing &&
    // "Payment History",
    "Vehicle Details",
    "Company Details",
    "Seller Details",
    isOngoing && "Disbursement",
  ].filter(Boolean);

  useEffect(() => {
    if (viewportWidth <= 767) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
    if (viewportWidth <= 1024) {
      setisTab(true);
    } else {
      setisTab(false);
    }
  }, [viewportWidth]);

  const GetOwnerType = (item, val) => {
    const temp = flooringSettingsData[`${item}`]?.filter(
      (it) => it.value == val
    );
    if (temp?.length > 0) {
      return temp[0]?.label;
    } else {
      return "";
    }
  };

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    // You can perform any other actions you need when a tab is changed here
  };

  const GetFloorCaseDetails = async () => {
    const resp = await axios.get(`/flooring/application/show/${AppId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp.status < 400) {
      setFloorCaseDetails(resp.data?.data);
    }
  };

  const GetFlooringSettings = async () => {
    const resp = await axios.get("/flooring/settings");
    if (resp.status < 400) {
      setFlooringSettingsData(resp.data?.data);
    }
  };

  const OnApplicationReject = async () => {
    const dataObj = {
      agent_approved_status: isReject.type,
      agent_voucher_approved_status: isReject.type,
      agent_interest_rate: 0,
      agent_admin_fee: 0,
      agent_other_conditions: "",
      preIssuedFloorAmount: "",
      undoRejected: true,
    };
    const resp = await axios.post(
      `/flooring/application/approvalStatus/${AppId}`,
      dataObj
    );
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      GetFloorCaseDetails();
      GetFlooringSettings();
      setisReject({ open: false, type: 2 });
    }
  };

  const PaymentStatus = async (status, ID, Obj) => {
    const resp = await axios.post(
      `/flooring/application/paymentStatusUpdate/${ID}`,
      Obj
    );
    if (resp.status < 400) {
      GetFloorCaseDetails();
      setisModelOpen({
        type: "Confirm",
        open: false,
        crntStatus: 1,
        amount: "",
        id: "",
      });
      setAgentRemarks("");
      toast.success(resp.data?.message);
    }
  };

  const handleselReject = () => {
    setisReject({ open: false, type: 2 });
  };

  const onModalSubmit = async () => {
    if (caseClose?.type === "Close Case") {
      try {
        const resp = await axios.post(
          `flooring/application/case-close/${AppId}`,
          {
            case_close_date: caseClose.date,
          }
        );
        if (resp.status < 400) {
          GetFloorCaseDetails();
          toast.success(resp.data.message);
          Reset();
        } else {
          Reset();
        }
      } catch (err) {
        toast.error("Case Not Closed..!");
      }
    } else {
      try {
        const resp = await axios.post(
          `flooring/application/repossess/${AppId}`,
          {
            repossess_date: caseClose.date,
          }
        );
        if (resp.status < 400) {
          GetFloorCaseDetails();
          toast.success(resp.data.message);
          Reset();
        } else {
          Reset();
        }
      } catch (err) {
        toast.error("Vehicle Not Repossesed..!");
      }
    }
  };

  useEffect(() => {
    if (AppId !== "" && AppId !== undefined) {
      GetFloorCaseDetails();
      GetFlooringSettings();
    }
  }, [AppId]);
  const Reset = () => {
    setcaseClose({
      open: false,
      type: "Close Case",
      isConfirm: false,
      date: null,
    });
  };
  const PaymentSummaryDetails = FloorCaseDetails?.ledger?.payment_summary;
  const CaseInfo = FloorCaseDetails?.case_info;

  /**case_close_date,repossess_date */

  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3 flex-wrap">
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/flooring-cases");
              }}
            >
              <BackIcon />
            </span>
            Flooring Cases
            <Button
              type="submit"
              className="sav_btn"
              onClick={() => {
                navigate("/flooring-cases/view/summary", {
                  state: { ...savedState, AgentId: AgentId },
                });
              }}
            >
              Case Summary
            </Button>
          </h1>
          {!isOngoing && (
            <div className="cases-publish">
              <h2>
                Publish on: <span>{DateValues?.submitted_date}</span>
              </h2>
              <h2>
                Case Expiry: <span>{DateValues?.expiry_date}</span>
              </h2>
            </div>
          )}
        </div>
      </header>
      {!isOngoing && (
        <section>
          <FlooringDetails
            FloorCaseDetails={FloorCaseDetails}
            openRejectPopup={(value, type) =>
              setisReject({ open: value, type: type })
            }
            AgentId={AgentId}
            AppId={
              savedState
            }
            activeTab={activeTab}
            GetFloorCaseDetails={GetFloorCaseDetails}
            pagePermission={pagePermission}
          />
        </section>
      )}
      <section>
        <div className="tab-section">
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          {/* {pagePermission?.update_permission == 1 && isOngoing && (
            <div className="header-btn-block">
              {(CaseInfo?.case_close_date !== null ||
                CaseInfo?.repossess_date === null) && (
                  <Button
                    className="sav_btn"
                    onClick={() => {
                      setcaseClose({
                        ...caseClose,
                        open: true,
                        type: "Close Case",
                      });
                    }}
                    disabled={
                      PaymentSummaryDetails?.redemption_amount !== "0.00" ||
                      CaseInfo?.case_close_date !== null ||
                      CaseInfo?.repossess_date !== null
                    }
                  >
                    <spa>
                      <CloseCase />
                    </spa>
                    {CaseInfo?.case_close_date !== null
                      ? "Flooring Case Completed"
                      : "Close Case"}
                  </Button>
                )}
              {(CaseInfo?.case_close_date === null ||
                CaseInfo?.repossess_date !== null) && (
                  <Button
                    className="can_btn reject_btn"
                    onClick={() => {
                      setcaseClose({
                        ...caseClose,
                        open: true,
                        type: "Repossess Vehicle",
                      });
                    }}
                    disabled={
                      CaseInfo?.case_close_date !== null ||
                      CaseInfo?.repossess_date !== null
                    }
                  >
                    <span>
                      <RepossessVehicle />
                    </span>
                    {CaseInfo?.repossess_date !== null
                      ? "Vehicle has been Repossessed"
                      : isMobile
                        ? "Repossess"
                        : "Repossess Vehicle"}
                  </Button>
                )}
            </div>
          )} */}
        </div>
        {/* {activeTab === 0 && isOngoing && (
          <section>
            <PaymentSummary
              isModelOpen={isModelOpen}
              setisModelOpen={setisModelOpen}
              FloorCaseDetails={FloorCaseDetails}
              PaymentStatus={PaymentStatus}
              agentRemarks={agentRemarks}
              setAgentRemarks={setAgentRemarks}
              OnClose={() => {
                setisModelOpen({
                  type: "Confirm",
                  open: false,
                  crntStatus: 1,
                  amount: "",
                  id: "",
                });
                setAgentRemarks("");
              }}
              GetFloorCaseDetails={GetFloorCaseDetails}
              pagePermission={pagePermission}
            />
          </section>
        )} */}

        <div className="tab-body-section">
          <div
            className={`view-flooring-cases ${activeTab === 6 && isOngoing ? "!pt-0" : "pt-5"
              }`}
          >
            {activeTab == (isOngoing ? 0 : 0) && (
              <VehicleDetails
                FloorCaseDetails={FloorCaseDetails}
                GetOwnerType={GetOwnerType}
              />
            )}
            {activeTab == (isOngoing ? 1 : 1) && (
              <CompanyDetails
                FloorCaseDetails={FloorCaseDetails}
                GetOwnerType={GetOwnerType}
              />
            )}
            {activeTab == (isOngoing ? 2 : 2) && (
              <SellerDetails
                FloorCaseDetails={FloorCaseDetails}
                GetOwnerType={GetOwnerType}
              />
            )}
            {activeTab == 3 && isOngoing && (
              <DisbursementDeatils
                FloorCaseDetails={FloorCaseDetails}
                GetOwnerType={GetOwnerType}
              />
            )}
            {/* {activeTab === 0 && isOngoing && (
              <PaymentHistory
                isModelOpen={isModelOpen}
                setisModelOpen={setisModelOpen}
                FloorCaseDetails={FloorCaseDetails}
                PaymentStatus={PaymentStatus}
                agentRemarks={agentRemarks}
                setAgentRemarks={setAgentRemarks}
                OnClose={() => {
                  setisModelOpen({
                    type: "Confirm",
                    open: false,
                    crntStatus: 1,
                    amount: "",
                    id: "",
                  });
                  setAgentRemarks("");
                }}
                GetFloorCaseDetails={GetFloorCaseDetails}
                pagePermission={pagePermission}
              />
            )} */}
          </div>
        </div>
      </section>
      <Modal
        open={isReject.open}
        onCancel={handleselReject}
        centered
        footer={null}
      >
        <div className="reject-popup-block">
          <h2 className="text-center">Reject Flooring Application?</h2>
          <div className="reject-popup-btn">
            <Button
              type="button"
              className="can_btn"
              onClick={() => {
                handleselReject();
              }}
            >
              Close
            </Button>
            <Button
              type="submit"
              className="sav_btn"
              onClick={() => {
                OnApplicationReject();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>

      {/* Case Closer*/}

      <Modal
        open={caseClose?.open}
        onCancel={() => Reset()}
        centered
        footer={null}
      >
        <div className="common-popup-block">
          <h2 className="text-center">{caseClose?.type}</h2>
          <p>
            {caseClose?.type === "Close Case"
              ? "Please ensure that there are no outstanding payable balance before closing this deal."
              : "The following vehicle wll be repossessed and this case terminated once confirmed"}
          </p>
          <div className="input-one-line">
            <div className="view-input-group">
              <label>Vehicle No</label>
              <h3>{FloorCaseDetails?.vehicleInfo?.vehicle_reg_no}</h3>
            </div>
            <div className="view-input-group">
              <label>Floor Start Date</label>

              <h3>
                {" "}
                {moment(
                  PaymentSummaryDetails?.flooring_start_date !== null
                    ? PaymentSummaryDetails?.flooring_start_date
                    : null,
                  "DD-MM-YYYY"
                )
                  ?.format("DD MMM YYYY")
                  ?.toUpperCase()}
              </h3>
            </div>
          </div>
          <div className="input-one-line">
            <div className="view-input-group">
              <label>Balance Amount Payable</label>
              <h3>
                ${FormatCurrency(PaymentSummaryDetails?.redemption_amount)}
              </h3>
              {/* <h3 className="error">$0.00</h3> */}
            </div>
          </div>
          {/* <Button className="can_btn deductions">Submit Deductions</Button> */}
          <div className="input-one-line !items-center mt-4">
            <Checkbox
              id="select_all"
              className="text-xs"
              checked={caseClose?.isConfirm}
              onChange={(e) => {
                setcaseClose({
                  ...caseClose,
                  isConfirm: e.target.checked,
                });
              }}
            >
              I confirm that this Flooring Case will be closed on
            </Checkbox>
            <DatePicker
              placeholder="DD-MM-YYYY"
              format={"DD-MM-YYYY"}
              className={`py-[8px] w-full md:max-w-[130px]`}
              value={
                caseClose?.date !== null && caseClose?.date !== undefined
                  ? dayjs(caseClose?.date, "DD-MM-YYYY")
                  : null
              }
              onChange={(date, dateString) => {
                setcaseClose({
                  ...caseClose,
                  date:
                    dateString !== null &&
                      dateString !== undefined &&
                      dateString !== ""
                      ? dateString
                      : null,
                });
              }}
              disabledDate={(d) => d.isBefore(dayjs().subtract(1, "days"))}
            />
          </div>
          <div className="reject-popup-btn">
            <Button
              type="button"
              className="can_btn"
              onClick={() => {
                Reset();
              }}
            >
              Close
            </Button>
            <Button
              className={`sav_btn`}
              disabled={caseClose?.date === null}
              onClick={() => {
                onModalSubmit();
              }}
            >
              {caseClose?.type === "Close Case" ? "Close Deal" : "Reposses"}
            </Button>
          </div>
        </div>
      </Modal>
    </section>
  );
};
export default ViewFlooringCases;
